import { useState } from "react";
import { courses } from "../Data/courses";
import { Card, CardContent, CardMedia, Button, Avatar } from "@mui/material";

const ITEMS_PER_PAGE = 9;

const CoursesGrid = () => {
  const [page, setPage] = useState(1);

  const totalPages = Math.ceil(courses.length / ITEMS_PER_PAGE);

  const startIndex = (page - 1) * ITEMS_PER_PAGE;
  const currentItems = courses.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 justify-items-center">
          {currentItems.map((course, i) => (
            <Card
              key={i}
              className="rounded-2xl shadow-lg overflow-hidden flex flex-col"
              sx={{ width: 300 }}
            >
              {/* IMAGE + STUDY NOW BUTTON */}
              <div className="relative">
                <CardMedia
                  component="img"
                  image={course.image}
                  alt={course.title}
                  sx={{ height: 170 }}
                />
                <Button
                  variant="contained"
                  sx={{
                    position: "absolute",
                    bottom: 12,
                    left: "50%",
                    transform: "translateX(-50%)",
                    px: 3,
                    py: 0.8,
                    fontSize: "0.8rem",
                    borderRadius: "20px",
                    backgroundColor: "#15803d",
                    textTransform: "none",
                    fontWeight: 600,
                    "&:hover": { backgroundColor: "#166534" },
                  }}
                >
                  Study Now
                </Button>
              </div>

              {/* CONTENT */}
              <CardContent className="space-y-4 flex-1 flex flex-col justify-between">
                <h3 className="font-semibold text-base leading-snug">{course.title}</h3>

                {/* STATS ROW */}
                <div className="flex justify-between text-center text-sm">
                  <div>
                    <p className="font-semibold text-green-700">{course.lessons}</p>
                    <p className="text-gray-500">lessons</p>
                  </div>
                  <div>
                    <p className="font-semibold text-green-700">{course.weeks}</p>
                    <p className="text-gray-500">weeks</p>
                  </div>
                  <div>
                    <p className="font-semibold text-green-700">{course.enrolled}</p>
                    <p className="text-gray-500">enroll</p>
                  </div>
                </div>

                {/* INSTRUCTOR + PRICE */}
                <div className="flex items-center justify-between bg-gray-100 rounded-xl p-3">
                  <div className="flex items-center gap-2">
                    <Avatar src={course.instructorImg} sx={{ width: 34, height: 34 }} />
                    <div>
                      <p className="text-sm font-medium">{course.instructor}</p>
                      <p className="text-xs text-gray-500">Arabic Teacher</p>
                    </div>
                  </div>
                  <div className="bg-yellow-400 text-black text-xs font-semibold px-3 py-1 rounded-lg text-center">
                    ${course.price} <br />
                   
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Pagination */}
        <div className="flex justify-center gap-3 mt-12">
          {Array.from({ length: totalPages }).map((_, index) => {
            const pageNumber = index + 1;
            return (
              <button
                key={pageNumber}
                onClick={() => setPage(pageNumber)}
                className={`px-4 py-2 rounded-md text-sm font-medium border ${
                  page === pageNumber
                    ? "bg-green-700 text-white border-green-700"
                    : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100",
                    window.scrollTo({ top: 0, behavior: "smooth" })
                }`}
              >
                {pageNumber}
              </button>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default CoursesGrid;
